import { Contents } from "@/view/pages/Conteudos/Contents";
import { ContentsAdmin } from "@/view/pages/Conteudos/ContentsAdmin";
import { TrainingDetails } from "@/view/pages/Conteudos/TraningDetails";
import TraningsDetails from "@/view/pages/Conteudos/TraningsDetails";
import { Reports } from "@/view/pages/Relatorios";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateLayout from "../view/layouts/PrivateLayout";
import { Login, Sellers } from "../view/pages";
import { Clientes } from "../view/pages/Clientes";
import { CustomerDetailsPage } from "../view/pages/Clientes/CustomerDetailsPage";
import { Configuracoes } from "../view/pages/Configuracoes";
import { Dashboard } from "../view/pages/Dashboard";
import { InvitePage } from "../view/pages/Invite";
import { Perfil } from "../view/pages/Perfil";
import { Teams } from "../view/pages/Times";
import { TeamsDetailsPage } from "../view/pages/Times/TeamsDetailsPage";
import { SellerDetailsPage } from "../view/pages/Vendedores/SellerDetailsPage";
import WithdrawSimulation from "../view/pages/WithdrawSimulation";
import { AuthGuard } from "./AuthGuard";
import { LessonDetails } from "@/view/pages/Conteudos/ClassDetails/LessonDetails";
import { UserRoleEnum } from "@/app/services/usersService/user";
import { RoleGuard } from "./RoleGuard";
import { AppEquipes } from "@/view/pages/AppEquipes";
import { Support } from "@/view/pages/Support";
import { Gerentes } from "@/view/pages/Gerentes";
import { Supervisores } from "@/view/pages/Supervisores";
import { ManagerDetailsPage } from "@/view/pages/Gerentes/ManagerDetailsPage";
import { ContentGuard } from "./ContentGuard";
import { DownloadRaffles } from "@/view/pages/Sorteios/DownloadRaffles";
import { TermsPage } from "@/view/pages/Terms";
import { ContactPage } from "@/view/pages/Contact";
import { WhitelabelLogin } from "@/view/pages/WhitelabelLogin";
import RecoverPassword from "@/view/pages/RecoverPassword";
import Register from "@/view/pages/Register";
import { PolicyPrivacyPage } from "@/view/pages/Policy";
import { RaffleLayout } from "@/view/pages/Sorteios/layout/RaffleLayout";
import { ManageRaffleDetailPage } from "@/view/pages/Sorteios/ManageRaffleDetailPage";
import { ManageRafflesPage } from "@/view/pages/Sorteios/ManageRafflesPage";
import { ViewRaffleDetailPage } from "@/view/pages/Sorteios/ViewRaffleDetailPage";
import { Raffles } from "@/view/pages/Sorteios";
import RaffleDetail from "@/view/pages/Sorteios/RaffleDetail";
import { useWhitelabelContext } from "@/app/contexts/whitelabelContext";
import { useShowSupportRequests } from "@/app/hooks/useShowSupportRequests";
import Credit from "@/view/pages/Credit";
import Links from "@/view/pages/Links";
import LinkDetails from "@/view/pages/Links/linkDetails";
// import { RaffleLayout } from '@/view/pages/Sorteios/layout/RaffleLayout'
// import RaffleDetail from '@/view/pages/Sorteios/RaffleDetail'
// import { Raffles } from '@/view/pages/Sorteios'
// import { ManageRaffleDetailPage } from '@/view/pages/Sorteios/ManageRaffleDetailPage'
// import { ManageRafflesPage } from '@/view/pages/Sorteios/ManageRafflesPage'
// import { ViewRaffleDetailPage } from '@/view/pages/Sorteios/ViewRaffleDetailPage'
import { AutoLogin } from "@/view/pages/AutoLogin";
import { PartnerGuard } from "./PartnerGuard";
import { PartnerType } from "@/app/utils/partners.enum";

import { CustomerLayout } from "@/view/pages/Clientes/layout/CustomerLayout";
import PanSimulation from "@/view/pages/PanSimulation";

import { Leads } from "@/view/pages/Leads";
import { RadarPage } from "@/view/pages/RadarPage";
import AvailableOffersClt from "@/view/pages/availableOffersClt";
import SelfHiringLayout from "@/view/layouts/SelfHiringLayout";
import C6BankSimulation from "@/view/pages/C6BankSimulation";
import C6BankOffers from "@/view/pages/C6BankOffers";
import CrefazCltSimulation from "@/view/pages/CrefazCltSimulation";
import SupportRequests from "@/view/pages/SupportRequests";

export function Router() {
  const { appConfig } = useWhitelabelContext();
  const showSupportRequests = useShowSupportRequests();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auto-login" element={<AutoLogin />} />
        <Route path="/invite/:id" element={<InvitePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/policy" element={<PolicyPrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/appEquipes" element={<AppEquipes />} />
        <Route path="/raffle/:raffleId/:userId" element={<DownloadRaffles />} />

        <Route element={<SelfHiringLayout />}>
          <Route path="/credit/:linkName" element={<Credit />} />
        </Route>

        <Route element={<AuthGuard isPrivate={false} />}>
          <Route path="/" element={<WhitelabelLogin />} />
          <Route path="/signIn" element={<Login />} />
          <Route path="/forgot-password" element={<RecoverPassword />} />
          <Route path="/code-recovery" element={<RecoverPassword />} />
          <Route path="/new-password" element={<RecoverPassword />} />
          {appConfig?.CAN_REGISTER && (
            <Route path="/register" element={<Register />} />
          )}
        </Route>

        <Route element={<AuthGuard isPrivate={true} />}>
          <Route element={<PrivateLayout />}>
            {/* ADMIN */}
            <Route element={<RoleGuard role={UserRoleEnum.ADMIN} />}>
              <Route path="/gerentes">
                <Route path="" element={<Gerentes />} />
                <Route path=":id" element={<ManagerDetailsPage />} />
              </Route>

              {appConfig?.prizes && (
                <Route path="/sorteios" element={<RaffleLayout />}>
                  <Route path="gerenciar">
                    <Route path="" element={<ManageRafflesPage />} />
                    <Route path=":id" element={<ManageRaffleDetailPage />} />
                    <Route path="view/:id" element={<ViewRaffleDetailPage />} />
                  </Route>
                </Route>
              )}

              <Route path="/configuracoes" element={<Configuracoes />} />
              {/* <Route path="/produtos" element={<PartnersPage />} /> */}
            </Route>

            {/* MANAGER */}
            <Route element={<RoleGuard role={UserRoleEnum.MANAGER} />}>
              <Route path="/supervisores" element={<Supervisores />} />
            </Route>

            {/* LEADER */}
            <Route element={<RoleGuard role={UserRoleEnum.LEADER} />}>
              <Route path="/vendedores" element={<Sellers />} />

              <Route path="/meutime/:id" element={<TeamsDetailsPage />} />
            </Route>

            {/* LEADER + SUPPORT */}
            <Route
              element={<RoleGuard role={UserRoleEnum.LEADER} allowSupport />}
            >
              <Route path="/times">
                <Route path=":id?" element={<Teams />} />
                <Route path="detalhes/:id" element={<TeamsDetailsPage />} />
              </Route>
            </Route>

            {/* USER / SELLER */}
            <Route element={<RoleGuard role={UserRoleEnum.USER} />}>
              <Route path="/transacoes">
                <Route path="" element={<Dashboard />} />

                <Route path=":cpf/clt" element={<AvailableOffersClt />} />

                <Route element={<PartnerGuard partner={PartnerType.FGTS} />}>
                  <Route path=":cpf" element={<WithdrawSimulation />} />
                </Route>

                <Route
                  path="/transacoes/pan/:propostaId"
                  element={<PanSimulation />}
                />

                <Route path=":cpf/c6" element={<C6BankSimulation />} />
                <Route path=":cpf/c6/offers" element={<C6BankOffers />} />

                <Route
                  path="/transacoes/crefaz-clt/:preTransactionId"
                  element={<CrefazCltSimulation />}
                />
              </Route>

              {/* <Route path="/clientes" element={<Clientes />} /> */}

              <Route path="/clientes" element={<CustomerLayout />}>
                <Route path="" element={<Clientes />} />
              </Route>
              <Route path="/radar" element={<RadarPage />} />
              <Route path="/leads" element={<Leads />} />

              <Route path="/relatorios" element={<Reports />} />
              <Route path="/links" element={<Links />} />
              <Route path="/links/:id" element={<LinkDetails />} />

              {showSupportRequests && (
                <Route path="/supports" element={<SupportRequests />} />
              )}
            </Route>

            {/* SUPPORT */}
            <Route element={<RoleGuard role={UserRoleEnum.SUPPORT} />}>
              <Route path="/support" element={<Support />} />
              <Route path="/clientes/:id" element={<CustomerDetailsPage />} />
              <Route path="/vendedores/:id" element={<SellerDetailsPage />} />
              <Route path="/perfil/:id" element={<Perfil />} />

              <Route path="/conteudos">
                <Route path="listar">
                  <Route path="" element={<Contents />} />
                  <Route
                    path="treinamentos/:id"
                    element={<TraningsDetails />}
                  />
                </Route>
              </Route>

              <Route path="/conteudos/gerenciar" element={<ContentGuard />}>
                <Route path="" element={<ContentsAdmin />} />
                <Route path="treinamentos/:id" element={<TrainingDetails />} />
                <Route
                  path="treinamentos/:trainingId/:lessonId"
                  element={<LessonDetails />}
                />
              </Route>

              {appConfig?.prizes && (
                <Route path="/sorteios">
                  <Route element={<RaffleLayout />}>
                    <Route path="" element={<Raffles />} />
                  </Route>
                  <Route path=":id" element={<RaffleDetail />} />
                </Route>
              )}
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
